import { IUser } from 'src/app/models/interfaces/user.interface';
import { FormMode } from '../../controls/common/form-mode';

export class UserFormContext {
    /**
     * Instance de l'utilisateur affiché dans le formulaire.
     */
    public item: IUser;

    /**
     * Indique si le formulaire est visible (true) ou pas (false).
     */
    public formVisible = false;

    public mode: FormMode = FormMode.Reading;
}
